export default __webpack_public_path__ + "static/media/Footer_phone.0560e355.svg";